import { module } from 'modujs';

export default class MailchimpForm extends module {

    static get settings() {
        return {
            CLASS_SUBMIT: 'is-submitting',
            CLASS_SUCCESS: 'is-success',
            CLASS_ERROR: 'has-error',
            STATE: {
                SUBMIT: 'submit',
                SUCCESS: 'success',
                ERROR: 'error',
            }
        }
    }

    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el
        this.$inputs = Array.from(this.$el.querySelectorAll('input'))
        this.$feedback = this.$('feedback')[0]

        // Vars
        this.formAction = this.$el.action.replace('/post?', '/post-json?')
        this.lang = this.$el.dataset.lang || 'fr'

        // Events
        this.events = {
            submit: 'handleFormSubmit'
        }
    }

    /**
     * Helper function for POSTing data as JSON with fetch.
     *
     * @param {Object} options
     * @param {string} options.url - URL to POST data to
     * @param {FormData} options.formData - `FormData` instance
     * @return {Object} - Response body from URL that was POSTed to
     */
    async postFormDataAsJson(url, formData) {
        const plainFormData = Object.fromEntries(formData.entries());

        const fetchOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(plainFormData),
        };

        const response = await fetch(url, fetchOptions);
        return response.json()
    }

    /**
     * Event handler for a form submit event.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormElement/submit_event
     *
     * @param {SubmitEvent} event
     */
    async handleFormSubmit(e) {
        e.preventDefault();

        this.setStatus(MailchimpForm.settings.STATE.SUBMIT)

        const form = e.currentTarget;

        const formData = new FormData(form);
        const responseData = await this.postFormDataAsJson(this.formAction, formData);

        const status = responseData.success ? MailchimpForm.settings.STATE.SUCCESS : MailchimpForm.settings.STATE.ERROR
        const message = responseData.data.message

        this.setStatus(status, message)

        setTimeout(() => {
            this.reset()
        }, 5000);
    }

    setStatus(status, message = '') {
        this.$feedback.innerHTML = message

        if (status === MailchimpForm.settings.STATE.SUBMIT) {
            this.$el.classList.add(MailchimpForm.settings.CLASS_SUBMIT)
        } else if (status === MailchimpForm.settings.STATE.SUCCESS) {
            this.$el.classList.remove(MailchimpForm.settings.CLASS_SUBMIT)
            this.$el.classList.add(MailchimpForm.settings.CLASS_SUCCESS)
        } else if (status === MailchimpForm.settings.STATE.ERROR) {
            this.$el.classList.remove(MailchimpForm.settings.CLASS_SUBMIT)
            this.$el.classList.add(MailchimpForm.settings.CLASS_ERROR)
        } else {
            this.$el.classList.remove(MailchimpForm.settings.CLASS_SUBMIT)
            this.$el.classList.remove(MailchimpForm.settings.CLASS_SUCCESS)
            this.$el.classList.remove(MailchimpForm.settings.CLASS_ERROR)
        }
    }

    reset() {
        for(let $input of this.$inputs) {
            $input.value = ''
        }
        this.setStatus()
    }

    destroy() {
        super.destroy();
    }
}
